import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useRoomSession } from '../../../../context/room_session';
import { artifactTimedResponse } from '@streem/sdk-core';
import { ToolbarButton } from './toolbar_button';
import { TooltipMessage } from './toolbar_tooltip_message';
export function StreemshotButton({ disabled, addNotification, roundLeftEdgeYn, roundRightEdgeYn, }) {
    const roomSession = useRoomSession();
    const [requestTimedOut, setRequestTimedOut] = useState(false);
    const [requesting, setRequesting] = useState(false);
    const tooltipMessage = useMemo(() => {
        return requestTimedOut ? 'Streemshot error. Click to retry.' : 'Take a Streemshot';
    }, [requestTimedOut]);
    const requestStreemshot = useCallback(async () => {
        const id = roomSession.streemshots.requestStreemshot();
        try {
            setRequestTimedOut(false);
            setRequesting(true);
            await artifactTimedResponse(id, roomSession.streemshots.responses);
            setRequesting(false);
            addNotification(id);
        }
        catch (error) {
            setRequestTimedOut(true);
            setRequesting(false);
            setTimeout(() => {
                setRequestTimedOut(false);
            }, 3000);
        }
    }, [roomSession.streemshots, addNotification]);
    return (_jsx(ToolbarButton, { "data-testid": "streemshot-button", showErrorMsg: requestTimedOut, iconName: "NewStreemshotsIcon", tooltipMessage: _jsx(TooltipMessage, { text: tooltipMessage }), label: "Streemshot", onClick: requestStreemshot, loading: requesting, disableButton: disabled, disableTooltip: disabled || requesting, roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: roundRightEdgeYn }));
}
//# sourceMappingURL=streemshot_button.js.map